var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-avatar flag__image">\n  \n</div>\n<div class="js-content flag__body">\n  \n</div>\n';
}
return __p;
};
